import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import config from '../../config';
import useCurrentUser from '../hooks/useCurrentUser';

const MORE_LINKS = [
  { to: '/fundraisers', label: 'Fundraisers' },
  { to: '/groups', label: 'Groups' },
  { to: '/integrations', label: 'Integrations' },
  { to: '/blog', label: 'Blog', partiallyActive: true },
];

export default function Header({ solid }) {
  const { currentUser, logout } = useCurrentUser();
  const { pathname } = useLocation();
  const [openMenu, setOpenMenu] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const [visibilityClass, setVisibilityClass] = useState('');
  const moreRef = useRef(null);
  const path = pathname.replace(/\/$/, '') || '/';
  const moreActive = MORE_LINKS.some(
    (item) => path === item.to || path.startsWith(`${item.to}/`)
  );

  const handleScroll = useCallback(() => {
    if (solid) {
      return;
    }
    setVisibilityClass((current) => {
      if (window.pageYOffset > 40) {
        return current !== 'navbar-shrink' ? 'navbar-shrink' : current;
      }
      return current === 'navbar-shrink' ? '' : current;
    });
  }, [solid]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    const closeMore = (event) => {
      if (moreRef.current && !moreRef.current.contains(event.target)) {
        setMoreOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setMoreOpen(false);
      }
    };
    document.addEventListener('mousedown', closeMore);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', closeMore);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  const closeMenus = () => {
    setMoreOpen(false);
    setOpenMenu(false);
  };

  const navClass = solid ? 'navbar-shrink' : visibilityClass;

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-light fixed-top ${navClass}`}
      id="mainNav"
    >
      <div className="container">
        <a className="navbar-brand" href="/#top">
          {config.siteTitle}
        </a>
        <button
          onClick={() => setOpenMenu((current) => !current)}
          className={`navbar-toggler navbar-toggler-right ${
            openMenu ? '' : 'collapsed'
          }`}
          type="button"
          aria-controls="navbarResponsive"
          aria-expanded={openMenu}
          aria-label="Toggle navigation"
        >
          Menu <i className="fas fa-bars"></i>
        </button>

        <div
          className={`collapse navbar-collapse ${openMenu ? 'show' : ''}`}
          id="navbarResponsive"
        >
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <a className="nav-link" href="/#pricing">
                Pricing
              </a>
            </li>
            <li className="nav-item">
              <Link
                to="/discover"
                className="nav-link"
                activeClassName="active"
              >
                Marketplace
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/competitions"
                className="nav-link"
                activeClassName="active"
              >
                Competitions
              </Link>
            </li>
            <li className="nav-item">
              <a
                href="#"
                onClick={(e) => {
                  window.Beacon('prefill', { subject: '', text: '' });
                  window.Beacon('navigate', '/ask/message');
                  window.Beacon('open');
                }}
                className="nav-link"
              >
                Contact
              </a>
            </li>
            <li className="nav-item">
              {currentUser ? (
                <a href="#" onClick={logout} className="nav-link">
                  Logout
                </a>
              ) : (
                <a href="https://admin.erg.zone/" className="nav-link">
                  Admin
                </a>
              )}
            </li>
            <li
              className={`nav-item dropdown nav-more${
                moreOpen ? ' is-open' : ''
              }`}
              ref={moreRef}
            >
              <button
                type="button"
                className={`nav-link dropdown-toggle${
                  moreActive ? ' active' : ''
                }`}
                aria-expanded={moreOpen}
                aria-haspopup="true"
                onClick={() => setMoreOpen((open) => !open)}
              >
                More
              </button>
              <div
                className={`dropdown-menu dropdown-menu-right${
                  moreOpen ? ' show' : ''
                }`}
                role="menu"
              >
                {MORE_LINKS.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="dropdown-item"
                    activeClassName="active"
                    partiallyActive={item.partiallyActive}
                    role="menuitem"
                    onClick={closeMenus}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
